export class DealerSignUpModel {
  companyName: string;
  companyPhone: string;
  addr1: string;
  addr2: string | null;
  city: string;
  state: string;
  zip: string;
  contactPhone: string;
  contactEmail: string;
  isSubmitted: boolean;
  contactFirstName: string;
  contactLastName: string;
  confirmationMessage: string | null;
  isErrored: boolean;
  isWaiting: boolean;
  distributor: string | null;
}



// WEBPACK FOOTER //
// ./src/app/dealer-sign-up/models/dealer-sign-up.model.ts